import React, { useCallback } from 'react';
import { Button } from 'devextreme-react/button';

const ButtonModalSK = ({
  data,
  modalSKOpen,
  stockReducer: { selectPlantId }
}) => {
  const onClick = useCallback(() => {
    modalSKOpen({
      plantId: selectPlantId,
      qcId: data.data.qcId,
      qcNumId: data.data.qcNumId,
      qcShop: data.data.qcShopCode,
      qcDate: data.data.accountingDate
    });
  }, [
    data,
    modalSKOpen,
    selectPlantId
  ]);
  return (
    <Button text={data.value}
            type="default"
            stylingMode="text"
            onClick={onClick}
    />
  );
};

export default React.memo(ButtonModalSK);
